export default "__VITE_ASSET__DPRAPd0A__"